<h3 color="primary" class="popup-header">Patient Details</h3>
<mat-dialog-content class="mat-typography">

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Demographics</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Last Name</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientLastName}}</li>

            <li fxFlex="11">First Name</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientFirstName}}</li>

            <li fxFlex="11">Middle Initial</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientMiddleInitial}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">DOB</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.dateOfBirth | date:'MM/dd/yyyy'}}</li>

            <li fxFlex="11">Gender</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.gender}}</li>

            <li fxFlex="11">Marital Status</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientsStatus}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">SSN</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.socialSecurityNumber}}</li>

            <li fxFlex="11">Alternative ID</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientsAlternativeId2}}</li>

            <li fxFlex="11">Account Number</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.accountNumber}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Med Rec No</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.medRecNo}}</li>

            <li fxFlex="11">Race</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.race}}</li>

            <li fxFlex="11">Ethnicity</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.ethnicity}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Driver License</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.driverLicense}}</li>

            <li fxFlex="11">Department</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.department}}</li>

            <li fxFlex="11">Title</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.title}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Identification</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.identificationDocument}}</li>

            <li fxFlex="11">ID Document#</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.idDocumentNumber}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Client Details</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Name</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.businessName}}</li>

            <li fxFlex="11">Address 1</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.address1}}</li>

            <li fxFlex="11">Address 2</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.address2}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">City</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.city}}</li>

            <li fxFlex="11">State</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.stateName}}</li>

            <li fxFlex="11">Zip</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.zip}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Contact Person</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.contactPerson}}</li>

            <li fxFlex="11">Contact Phone</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{clientInfo?.contactNumber}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Current Medications and ICD Codes</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="10">Medications</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="88" primaryColor>{{medications}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="10">ICD Codes</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="88" primaryColor>{{icdCodes}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Address</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Address 1</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientAddress1}}</li>

            <li fxFlex="11">Address 2</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientAddress2}}</li>

            <li fxFlex="11">City</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientCity}}</li>
          </div>
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">State</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientState}}</li>

            <li fxFlex="11">County</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.county}}</li>

            <li fxFlex="11">Zip Code</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientZip}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Contact Information</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="11">Phone Number</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.phoneNumber}}</li>

            <li fxFlex="11">Alternate Phone</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.otherPhone}}</li>

            <li fxFlex="11">Email Address</li>
            <li fxFlex="2"> : </li>
            <li fxFlex="20" primaryColor>{{patientInfo?.patientsEmail}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
    <mat-card class="generalInfo">
      <mat-card-header>
        <mat-card-title>
          <span class="card-title-text">Notes</span>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <ul class="generalInfo_details">
          <div fxLayout="row wrap" fxLayout.sm="column" fxLayout.xs="column">
            <li fxFlex="100" primaryColor>{{patientInfo?.notes}}</li>
          </div>
        </ul>
      </mat-card-content>
    </mat-card>
  </div>

  <div class="section-content" fxLayout="column">
    <div><b>Patient Insuarance Detail : </b></div>
    <div>
      <table class="detailTable">
        <tr>
          <th>Insurance type</th>
          <th>Company</th>
          <th>Policy Id</th>
          <th>Insured Name</th>
          <th>Guarantor Name</th>
          <th>No Insurance</th>
        </tr>
        <tr *ngFor="let item of insuranceInfo">
          <td>{{item?.viewInsuranceType}}</td>
          <td>{{item?.companyName}}</td>
          <td>{{item?.viewPolicyid}}</td>
          <td>{{item?.viewFullName}}</td>
          <td>{{item?.viewGuarantorName}}</td>
          <td>{{item?.viewNoInsurance}}</td>
        </tr>
      </table>
    </div>
  </div>

</mat-dialog-content>
<mat-dialog-actions class="popup-footer">
  <button mat-raised-button color="warn" (click)="cancelClick()">
    <i class="fas fa-times"></i> Close
  </button>
</mat-dialog-actions>